import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=4bee25b2&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=4bee25b2&scoped=true&lang=css&"
import style1 from "./detail.vue?vue&type=style&index=1&id=4bee25b2&scoped=true&lang=scss&"
import style2 from "./detail.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bee25b2",
  null
  
)

export default component.exports